const TrueRequired = (value, row, object) => {
    if (!value || value == "0") {
        return "is required";
    }
};

export default TrueRequired;
